import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const TerreoPagina = () => {
  return (
    <div className="terreo-container">
      <h1>Controle de Iluminação - Térreo</h1>
      <GroupLightComponent 
        groupIds={[
          "grupo01",
          "grupo02", 
          "grupo06",
          "grupo10",
          "grupo11", 
          "grupo12",
          "grupo13",
          "grupo14",
          "grupo15", 
          "grupo16", 
          "grupo17", 
          "grupo18", 
          "grupo19", 
          "grupo20",
          "grupo21",
          "grupo22",
          "grupo23",
          "grupo24",
          "grupo25",
          "grupo26",
        ]}
        pageTitle="Luzes do Térreo" 
        pageId="2"
      />
    </div>
  );
};

export default TerreoPagina;